<!--
 * @Author: zhechuan.Wang
 * @Date: 2023-11-17 10:06:45
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2024-03-15 14:39:58
 * @Description: 补贴项目公示
 * @FilePath: \gfmis-card-ppt\src\views\subsidize\subsidizeProject.vue
-->
<template>
  <div class="pageRoot" :class="tableData.length > 5 ? 'pageRootNew' : ''">
    <head-com class="head-com" :headObj="headObj"></head-com>
    <tree-table-com ref="treeTableRef" class="content" v-loading="loading" v-bind="tableConfig"
      :tablePageConfig="pageConfig" :treeData="treeList" :tableData="tableData" @cellClick="cellClick"
      @node-click="treeNodeClick" @searchChange="searchChange" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
      <template #spNameHeader="{ column }">
        <div>
          <span>{{ column.label }}</span>
          <el-checkbox v-model="isValid" @change="checkboxChange" style="margin-left: 15px">含失效项目</el-checkbox>
        </div>
      </template>
      <template #fileList="{ row }">
        <div>
          <el-button size="mini" :type="row.isBtnDisable ? 'info' : 'primary'" :disabled="row.isBtnDisable"
            @click="handleReadFile(row)">查看详情</el-button>
        </div>
      </template>
    </tree-table-com>
    <component ref="dialogRef" v-if="dialogInfo.component && dialogInfo.showDialog" v-bind="dialogInfo"
      :showDialog.sync="dialogInfo.showDialog" :is="dialogInfo.component" />
  </div>
</template>

<script>
import Api from '@/api/cardProject'
import commonJs from '@/views/mixins/common'

import headCom from '@/components/headCom.vue';
import treeTableCom from '@/components/treeTableCom.vue'
import fileListDialog from './components/dialog/fileListDialog.vue'

export default {
  name: 'SubsidizeProject',
  mixins: [commonJs],
  data() {
    return {
      Api,
      headObj: {
        cnTitleName: '补贴项目公示',
        enTitleName: 'SUBSIDY PROJECTS LIST'
      },
      tableConfig: {
        isShowTree: true,
        isDisabledNode: true,
        isGerDefaultTreeData: false,
        titleTvArray: [],
        cellClassName: this.cellClassName,
        tableColumn: [
          {
            field: 'spName',
            title: '补贴项目',
            isChangeColumnHeader: true,
            slots: {
              slotHead: 'spNameHeader',
            },
            width: 200
          },
          {
            field: 'spLevelName',
            title: '项目级次',
            width: 200,
          },
          {
            field: 'objInfo',
            title: '补贴范围(对象)',
          },
          {
            field: 'staInfo',
            title: '补贴标准',
          },
          {
            field: 'conTel',
            title: '咨询电话',
            width: 120
          },
          {
            field: 'fileList',
            title: '政策文件',
            slots: {
              default: 'fileList'
            },
            width: 120
          },
        ],
        tableData: [],
      },
      searchParam: '',
      mofDivCode: '',
      mofDivName: '',
      isValid: false, // 是否含已失效项目
      dialogInfo: {
        component: null,
        showDialog: false,
      },
    };
  },
  components: {
    headCom,
    treeTableCom
  },
  async mounted() {
    await this.getTreeData()
    // if (this.treeList.length > 0) {
    //   this.$store.commit('setCurrentNode', { mofDivCode: this.mofDivCode, mofDivName: this.mofDivName })
    // }
    this.tableConfig.titleTvArray = [this.mofDivName, '惠民惠农财政补贴项目清单']
    this.getList()
  },
  methods: {
    handleReadFile(item) {
      if (item.isBtnDisable) {
        return;
      }
      this.dialogInfo = {
        component: fileListDialog,
        showDialog: true,
        formResult: item.cardAttachments || []
      };
    },
    async cellClick({ column, row }) {
      if (column?.property === 'spName') {
        const rowData = {
          ...row,
        }
        await this.$store.commit('setSpName', row.spName)
        const { mofDivCode, spId } = rowData
        this.$router.push({ name: 'SubsidizePubInfo', query: { mofDivCode, spId } })
      }
    },
    cellClassName({ column, columnIndex, row, rowIndex }) {
      if (column.property === 'spName' && row[column.property]) {
        return row.isValid == 1 ? 'blue-color' : 'gray-color';
      }
    },
    checkboxChange() {
      this.getList();
    },
    getListBefore({ currentPage = this.pageConfig.currentPage, pageSize = this.pageConfig.pageSize }) {
      this.tableData = []
      return {
        method: this.Api.getList,
        args: {
          currentPage,
          pageSize,
          model: {
            mofDivCode: this.mofDivCode,
            spName: this.searchParam,
            isValid: this.isValid ? 2 : 1
          }
        },
      };
    },
    getListAfter() {
      this.tableData.forEach(el => {
        el.isBtnDisable = !el.cardAttachments?.length
        // el.spName = `<span style="color: red">${el.spName}</span>`
      })
    },
  },
};
</script>
<style scoped lang="scss">
.pageRootNew {
  height: initial;
  min-height: 100%;
  max-height: calc(100% + 140px);
}
</style>
